import { render, staticRenderFns } from "./AboutParallax.vue?vue&type=template&id=352fc549&"
import script from "./AboutParallax.vue?vue&type=script&lang=js&"
export * from "./AboutParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports